/* HALLOW theme JS — small, vanilla, no dependencies. */
(function () {
  'use strict';

  const $ = (s, c) => (c || document).querySelector(s);
  const $$ = (s, c) => Array.from((c || document).querySelectorAll(s));
  const money = (cents) => {
    if (window.Shopify && window.Shopify.formatMoney) {
      return window.Shopify.formatMoney(cents, window.theme && window.theme.moneyFormat);
    }
    return '£' + (cents / 100).toFixed(2);
  };

  /* ----- Cart drawer open/close ----- */
  const drawer = $('#cart-drawer');
  const backdrop = $('#cart-drawer-backdrop');

  function openDrawer() {
    if (!drawer) return;
    drawer.classList.add('open');
    backdrop && backdrop.classList.add('open');
    document.body.classList.add('no-scroll');
    refreshDrawer();
  }
  function closeDrawer() {
    drawer && drawer.classList.remove('open');
    backdrop && backdrop.classList.remove('open');
    document.body.classList.remove('no-scroll');
  }
  $$('[data-cart-open]').forEach(el => el.addEventListener('click', (e) => { e.preventDefault(); openDrawer(); }));
  $$('[data-cart-close]').forEach(el => el.addEventListener('click', closeDrawer));
  backdrop && backdrop.addEventListener('click', closeDrawer);
  document.addEventListener('keydown', (e) => { if (e.key === 'Escape') closeDrawer(); });

  /* ----- Refresh drawer via /cart.js ----- */
  async function refreshDrawer() {
    try {
      const res = await fetch('/cart.js', { headers: { 'Accept': 'application/json' } });
      const cart = await res.json();
      renderDrawer(cart);
      updateBubble(cart.item_count);
    } catch (err) { console.warn('Cart refresh failed', err); }
  }

  function renderDrawer(cart) {
    const body = $('#cart-drawer-body');
    if (!body) return;
    if (cart.item_count === 0) {
      body.innerHTML = '<p style="font-family:var(--hallow-display);font-style:italic;font-size:18px;color:var(--hallow-sub);text-align:center;padding:40px 0;">Your bag is empty.</p>';
      $('#cart-drawer-foot') && ($('#cart-drawer-foot').style.display = 'none');
      return;
    }
    $('#cart-drawer-foot') && ($('#cart-drawer-foot').style.display = 'block');
    body.innerHTML = cart.items.map(item => `
      <div class="cart-line" data-key="${item.key}">
        <img class="cart-line__img" src="${item.image || ''}" alt="${item.product_title}">
        <div>
          <div class="cart-line__type">${item.product_type || ''}</div>
          <div class="cart-line__title">${item.product_title}</div>
          <div class="cart-line__qty">
            <button data-qty-down>−</button>
            <span>${item.quantity}</span>
            <button data-qty-up>+</button>
            <a href="#" data-qty-remove style="margin-left:14px;color:var(--hallow-sub);text-decoration:underline;">Remove</a>
          </div>
        </div>
        <div style="font-family:var(--hallow-body);font-size:14px;">${money(item.final_line_price)}</div>
      </div>
    `).join('');

    $('#cart-total') && ($('#cart-total').textContent = money(cart.total_price));
    $('#cart-ship') && ($('#cart-ship').textContent = cart.total_price >= 4000 ? 'Free' : '£4.50');

    // wire qty controls
    $$('#cart-drawer-body .cart-line').forEach(line => {
      const key = line.dataset.key;
      const qtyEl = line.querySelector('.cart-line__qty span');
      const current = parseInt(qtyEl.textContent, 10);
      line.querySelector('[data-qty-up]').addEventListener('click', () => changeLine(key, current + 1));
      line.querySelector('[data-qty-down]').addEventListener('click', () => changeLine(key, Math.max(0, current - 1)));
      line.querySelector('[data-qty-remove]').addEventListener('click', (e) => { e.preventDefault(); changeLine(key, 0); });
    });
  }

  async function changeLine(key, quantity) {
    const res = await fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ id: key, quantity })
    });
    const cart = await res.json();
    renderDrawer(cart);
    updateBubble(cart.item_count);
  }

  function updateBubble(count) {
    $$('[data-cart-count]').forEach(el => { el.textContent = count; });
  }

  /* ----- Ajax add-to-cart for product cards (the hover "+ Add" button) ----- */
  $$('[data-ajax-add]').forEach(form => {
    form.addEventListener('submit', async (e) => {
      e.preventDefault();
      const fd = new FormData(form);
      try {
        const res = await fetch('/cart/add.js', { method: 'POST', body: fd, headers: { 'Accept': 'application/json' } });
        if (res.ok) {
          openDrawer();
        } else {
          const err = await res.json();
          alert(err.description || 'Could not add to cart.');
        }
      } catch (err) { alert('Network error.'); }
    });
  });

  /* ----- Product page tabs (theme.css uses [hidden]) ----- */
  $$('.product-tabs').forEach(scope => {
    const buttons = $$('.product-tabs__nav button', scope);
    const panels = $$('.product-tabs__panel', scope);
    buttons.forEach(btn => btn.addEventListener('click', () => {
      buttons.forEach(b => b.classList.remove('active'));
      panels.forEach(p => p.hidden = true);
      btn.classList.add('active');
      const id = btn.dataset.target;
      const panel = scope.querySelector('[data-panel="' + id + '"]');
      if (panel) panel.hidden = false;
    }));
  });

  /* ----- Product page: thumbnail gallery & qty ----- */
  const productGallery = $('[data-product-gallery]');
  if (productGallery) {
    const mainImg = $('[data-product-gallery-main] img', productGallery);
    $$('[data-product-thumb]', productGallery).forEach(btn => {
      btn.addEventListener('click', () => {
        $$('[data-product-thumb]', productGallery).forEach(b => b.setAttribute('aria-pressed', 'false'));
        btn.setAttribute('aria-pressed', 'true');
        const src = btn.querySelector('img').dataset.large || btn.querySelector('img').src;
        const alt = btn.querySelector('img').alt;
        mainImg.src = src;
        mainImg.alt = alt;
      });
    });
  }

  const qtyEl = $('[data-qty]');
  if (qtyEl) {
    const input = qtyEl.querySelector('input');
    qtyEl.querySelector('[data-qty-down]').addEventListener('click', () => { input.value = Math.max(1, parseInt(input.value, 10) - 1); });
    qtyEl.querySelector('[data-qty-up]').addEventListener('click', () => { input.value = parseInt(input.value, 10) + 1; });
  }

  /* ----- Newsletter (just visual, real submit goes to /contact#newsletter) ----- */
  // No JS needed; form posts to Shopify's contact endpoint.

  /* ----- Initial draw of the cart bubble ----- */
  refreshDrawer();

})();
